import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const invoiceApi = createApi({
  reducerPath: "invoiceApi",

  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["invoiceApi"],
  endpoints: (builder) => ({
    findByCustomerId: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.invoiceDetailController.findByCustomerId,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});


export const { useFindByCustomerIdMutation } = invoiceApi;
